'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("circle", {
    id: "realty-type-apartment_svg__a",
    cx: 28,
    cy: 28,
    r: 28
  })), /*#__PURE__*/React__namespace.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "realty-type-apartment_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#realty-type-apartment_svg__a"
  })), /*#__PURE__*/React__namespace.createElement("use", {
    fill: "#1098F3",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 -1 0 56)",
    xlinkHref: "#realty-type-apartment_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    mask: "url(#realty-type-apartment_svg__b)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M24.365 12.805c0 6.67-5.406 12.076-12.076 12.076-6.67 0-12.076-5.406-12.076-12.076C.213 6.135 5.62.729 12.289.729c6.67 0 12.076 5.406 12.076 12.076",
    fill: "#3F3E4B",
    opacity: 0.2,
    style: {
      mixBlendMode: 'multiply'
    },
    transform: "translate(12 12.889)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M33.865 22.108H20.081v20.184h13.784z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M33.865 22.108H20.081v20.184h13.784V22.108Zm-.985.984v18.216H21.065V23.092H32.88Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E9EAE6",
    d: "M22.05 22.6h9.846v-2.462H22.05z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M32.388 19.646h-10.83v3.446h10.83v-3.446Zm-.985.985v1.477h-8.861V20.63h8.861Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFF",
    d: "M25.988 41.8h2.954V37.86h-2.954z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M29.435 37.37h-3.939v4.922h3.939V37.37Zm-.986.984v2.954H26.48v-2.954h1.97ZM25.988 26.538h-3.446v3.447h3.446v-3.447Zm-.985.985V29h-1.477v-1.477h1.477ZM25.988 30.477h-3.446v3.446h3.446v-3.446Zm-.985.984v1.477h-1.477v-1.477h1.477Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M21.065 29h-5.907v13.292h5.907z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M20.08 29.985v11.323h-3.938V29.985h3.938Zm.985-.985h-5.907v13.292h5.907V29Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E9EAE6",
    d: "M17.127 29.492h3.446v-2.461h-3.446z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M21.065 26.538h-4.43v3.447h4.43v-3.447Zm-.985.985V29H17.62v-1.477h2.461Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M33.409 26.046a5.38 5.38 0 0 0-5.379 5.38c0 4.642 4.587 5.27 4.973 9.99a.41.41 0 0 0 .406.384.411.411 0 0 0 .407-.384c.385-4.72 4.972-5.348 4.972-9.99a5.38 5.38 0 0 0-5.379-5.38",
    fill: "#BFBEC8"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M33.409 25.554a5.872 5.872 0 0 0-5.871 5.872c0 2.068.613 3.211 2.377 5.193l.406.452c1.452 1.625 2.053 2.691 2.191 4.385a.903.903 0 0 0 .897.836.903.903 0 0 0 .897-.836c.139-1.694.74-2.76 2.193-4.386l.25-.28c1.883-2.088 2.532-3.237 2.532-5.364a5.872 5.872 0 0 0-5.872-5.872Zm0 .984c2.7 0 4.887 2.188 4.887 4.888 0 1.506-.375 2.427-1.489 3.793l-.24.289-.264.304-.14.158-.397.443-.151.17c-1.23 1.4-1.892 2.48-2.168 3.891l-.038.21-.005-.03c-.265-1.56-.971-2.697-2.35-4.24l-.253-.281a31.859 31.859 0 0 1-.42-.475l-.252-.296c-1.206-1.446-1.607-2.379-1.607-3.936 0-2.7 2.188-4.888 4.887-4.888Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M35.342 31.461a1.97 1.97 0 1 1-3.938 0 1.97 1.97 0 0 1 3.938 0",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M33.373 29a2.462 2.462 0 1 0 0 4.923 2.462 2.462 0 0 0 0-4.923Zm0 .985a1.477 1.477 0 1 1 0 2.954 1.477 1.477 0 0 1 0-2.954ZM17.62 20.138v.985h-3.447v-.985h3.446Zm1.968 0v.985h-.984v-.985h.984Zm18.927-3.632c.83 0 1.58.361 2.065.979l.022.03.032-.002c.844-.015 1.5.324 1.896 1.06l.045.088h1.137v.985h-1.815l-.115-.331c-.222-.643-.605-.868-1.276-.81l-.093.01-.322.04-.163-.281c-.284-.49-.806-.783-1.413-.783-.981 0-1.59.53-1.636 1.558l-.003.108-.003.49h-2.515v-.986h1.57l.016-.1c.227-1.263 1.168-2.011 2.457-2.053l.114-.002Zm-16.674-2.973c1.17 0 2.226.663 2.786 1.666l.018.034.08-.014c.044-.006.089-.011.134-.014l.135-.005c.682 0 1.332.375 1.744.907l.068.093h3.12v.985h-3.698l-.137-.269c-.208-.406-.667-.731-1.097-.731-.11 0-.224.02-.345.06l-.092.033-.467.187-.177-.47c-.327-.874-1.156-1.478-2.072-1.478-1.027 0-2.146 1.21-2.212 2.1l-.003.077-.001.49h-4.467V16.2H18.7l.019-.075c.328-1.242 1.64-2.527 3.015-2.59l.106-.002ZM31.896 16.2v.985h-.984V16.2h.984Zm1.97 0v.985h-.985V16.2h.984ZM13.188 41.308v1h-.984v-1h.984Zm28.554 0v1h-1.969v-1h1.97Zm1.97 0v1h-.985v-1h.985Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }))));
});
var RealtyTypeApartment = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.RealtyTypeApartment = RealtyTypeApartment;